import React, {FC} from 'react';
import {motion} from 'framer-motion';

import * as styles from './styles.module.scss';

type StepsReviewItemProps = {
    name?: string
    description: string
}

const StepsReviewItem: FC<StepsReviewItemProps> = ({name, description}) => {
	const sectionProps = {
		className: styles.section,

		initial: 'hidden',
		whileInView: 'show',
		viewport: {once: true},

		transition: {
			duration: 0.5,
		},
		variants: {
			hidden: {
				opacity: 0,
				x: '+20%',
				'--text-blur': '5px',
			},
			show: {
				opacity: 1,
				x: 0,
				'--text-blur': '0px',
			},
		},
	};

	return (
		<motion.div {...sectionProps}>
			<div className={styles.item}>
				<div className={styles.name}>{name}</div>
				<div className={styles.description}>{description}</div>
			</div>
		</motion.div>
	);
};

export default StepsReviewItem;
